import React from "react";
import { GlobalModal } from "../../../../global/GlobalModal";
import { GlobalButton } from "../../../../global/forms/GlobalFormFields";
import MyTournamentsCertificateButton from "./MyTournamentsCertificateButton";
import {
  formatTournamentAmount,
  formatTournamentDate,
  tournamentStatusBadgeClass,
} from "../../utils/myTournamentsDirectoryHelpers";

function DetailTile({ label, value, mono }) {
  return (
    <div className="mm-modal-tile">
      <span className="mm-modal-tile__label">{label}</span>
      <span className={`mm-modal-tile__value${mono ? " mm-modal-tile__value--mono" : ""}`}>
        {value ?? "—"}
      </span>
    </div>
  );
}

function PaymentStatusPill({ status, verified }) {
  const s = String(status || "").toLowerCase();
  let cls = "mm-pay-pill mm-pay-pill--muted";
  if (s === "paid") cls = "mm-pay-pill mm-pay-pill--paid";
  else if (s === "pending") cls = "mm-pay-pill mm-pay-pill--pending";
  else if (s === "no payment") cls = "mm-pay-pill mm-pay-pill--none";

  return (
    <span className={cls}>
      {status || "—"}
      {verified != null ? (
        <span className="mm-pay-pill__sub">
          {verified ? " · Verified" : " · Not verified"}
        </span>
      ) : null}
    </span>
  );
}

export default function MyTournamentsDetailModal({ row, onClose, onFeedback }) {
  const open = Boolean(row);

  return (
    <GlobalModal
      open={open}
      onClose={onClose}
      size="lg"
      classNames={{
        modal: "gff-modal mm-detail-modal",
        body: "gff-modal__body mm-detail-modal__shell",
      }}
    >
      {row ? (
        <div className="mm-detail-modal__body">
          <header className="mm-detail-modal__hero">
            <button
              type="button"
              className="mm-detail-modal__close"
              onClick={onClose}
              aria-label="Close"
            >
              ×
            </button>
            <div className="mm-detail-modal__hero-top">
              <span className="mm-detail-modal__source">Tournament details</span>
              <span className={tournamentStatusBadgeClass(row.status)}>
                {row.status || "—"}
              </span>
            </div>
            <h2 className="mm-detail-modal__title">
              {row.tournament_name || "Tournament"}
            </h2>
            <p className="mm-detail-modal__code">{row.tournament_id || "—"}</p>
          </header>

          <div className="mm-detail-modal__grid">
            <section className="mm-detail-modal__card" aria-label="Tournament information">
              <h3 className="mm-detail-modal__card-title">
                <span className="mm-detail-modal__card-icon" aria-hidden>
                  ◆
                </span>
                Tournament information
              </h3>
              <div className="mm-detail-modal__card-body mm-detail-modal__card-body--grid">
                <DetailTile label="Tournament ID" value={row.tournament_id} mono />
                <DetailTile label="Sport type" value={row.sport_type} />
                <DetailTile label="Tournament level" value={row.tournament_level} />
                <DetailTile
                  label="Date"
                  value={formatTournamentDate(row.tournament_date)}
                />
                <DetailTile label="Venue" value={row.location} />
                <DetailTile
                  label="Participation fee"
                  value={formatTournamentAmount(row.participation_fee)}
                />
                <DetailTile
                  label="Registration status"
                  value={row.participation_status}
                />
                <DetailTile label="Result" value={row.result} />
                <DetailTile
                  label="Certificate issued"
                  value={row.certificate_issued || "No"}
                />
              </div>
            </section>

            <section
              className="mm-detail-modal__card mm-detail-modal__card--payment"
              aria-label="Payment details"
            >
              <h3 className="mm-detail-modal__card-title">
                <span className="mm-detail-modal__card-icon" aria-hidden>
                  ₹
                </span>
                Payment details
              </h3>
              <div className="mm-detail-modal__pay-amount">
                <span className="mm-detail-modal__pay-label">Amount paid</span>
                <strong className="mm-detail-modal__pay-value">
                  {formatTournamentAmount(row.payment_amount ?? row.participation_fee)}
                </strong>
                <PaymentStatusPill
                  status={row.payment_status}
                  verified={row.payment_verified}
                />
              </div>
              <div className="mm-detail-modal__card-body mm-detail-modal__card-body--grid">
                <DetailTile
                  label="Payment date"
                  value={formatTournamentDate(row.payment_date)}
                />
                <DetailTile label="Payment mode" value={row.payment_mode} />
                <DetailTile label="Receipt no." value={row.receipt_no} mono />
                <DetailTile label="Transaction ID" value={row.transaction_id} mono />
                <DetailTile
                  label="Participation fee"
                  value={formatTournamentAmount(row.participation_fee)}
                />
              </div>
            </section>
          </div>

          <footer className="mm-detail-modal__footer mm-detail-modal__footer--split">
            <MyTournamentsCertificateButton row={row} onFeedback={onFeedback} />
            <GlobalButton type="button" variant="primary" size="sm" onClick={onClose}>
              Close
            </GlobalButton>
          </footer>
        </div>
      ) : null}
    </GlobalModal>
  );
}
